import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH } from '~/constants/common';

export const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 16,
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    flexDirection: 'column',
  },
}));
